import { render, staticRenderFns } from "./Preview-Reports.vue?vue&type=template&id=0c8120fb&scoped=true"
import script from "./Preview-Reports.vue?vue&type=script&lang=js"
export * from "./Preview-Reports.vue?vue&type=script&lang=js"
import style0 from "./Preview-Reports.vue?vue&type=style&index=0&id=0c8120fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8120fb",
  null
  
)

export default component.exports